module.exports = function(item, view){
	if(!item.start_date || !item.end_date){
		return null;
	}
	var padding = 200;
	var startCoord = view.posFromDate(item.start_date);
	var endCoord = view.posFromDate(item.end_date);
	var left = Math.min(startCoord, endCoord) - padding;
	var right = Math.max(startCoord, endCoord) + padding;
	var config = view.$getConfig();
	return {
		top: view.getItemTop(item.id),
		height: config.row_height,
		left: left,
		width: right - left
	};
};